export default {
    getNotes: (projectId, issueId) => {
        return {
            url: '/projects/:projectId/issues/:issueId/notes',
            method: 'GET',
            route_params: {
                projectId,
                issueId
            }
        };
    },
    createNote: (projectId, issueId, body) => {
        return {
            url: '/projects/:projectId/issues/:issueId/notes',
            method: 'POST',
            route_params: {
                projectId,
                issueId
            },
            post_params: {
                body
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/ticketsgit/data/Notes/api.js